import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getTimeZone } from '../../../contexts/User/helpers/userContextHelpers';
import { userProviderPropsMap } from '../../../contexts/User/userProviderPropsMap';
import { createParticipant } from '../../../contexts/User/helpers/createParticipant';
import { createOrder } from '../../../contexts/User/helpers/payForChallenge';
import { coupons } from './coupons';
import { getParticipantState } from '../../../selectors/participant/getState';
import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';

export async function prepareUserForPayment(flowAPI: ControllerFlowAPI) {
  const timeZone = getTimeZone(flowAPI);
  const userProvider = await userProviderPropsMap(flowAPI);

  const participant = await createParticipant({
    timeZone,
    flowAPI,
    userProvider,
  });

  // if participant is JOIN_REQUESTED, no need to create order
  if (getParticipantState(participant) === ParticipantState.JOIN_REQUESTED) {
    return null;
  }

  const { participant: participantWithOrder } = await createOrder({
    flowAPI,
    paymentOption: 'SinglePayment',
    timeZone,
  });

  return {
    participant: participantWithOrder,
    ...(await coupons(flowAPI)),
  };
}
